import { DeveloperProfileConstants } from "sj-ui-toolkit/src/constants/developerProfile";

export const FIELD_TYPES = {
  TEXT: "text",
  DROPDOWN: "dropdown",
  MULTISELECT: "multiselect",
};

export const PROFILE_FIELD_KEYS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  COUNTRY: "country",
  EMAIL: "email",
  COMPANY: "company",
  TITLE: "title",
  ROLE: "role",
  FUNCTION: "function",
  EXPERIENCE: "experience",
  EXPERTISE: "expertise",
  LANGUAGE: "language",
  TOOLING: "tooling",
};

// Temporarily disabling email editing for all users
// TODO: Add user initatied email change flow - shrpa:3089 as reference
export const ALWAYS_LOCKED_FIELDS = [PROFILE_FIELD_KEYS.EMAIL];

export const SSO_LOCKED_FIELDS = [
  PROFILE_FIELD_KEYS.FIRST_NAME,
  PROFILE_FIELD_KEYS.LAST_NAME,
  PROFILE_FIELD_KEYS.COUNTRY,
  PROFILE_FIELD_KEYS.EMAIL,
  PROFILE_FIELD_KEYS.COMPANY,
  PROFILE_FIELD_KEYS.TITLE,
  PROFILE_FIELD_KEYS.ROLE,
];

export const FIELD_GROUPS = [
  {
    fields: [
      { label: "First Name", key: PROFILE_FIELD_KEYS.FIRST_NAME, type: FIELD_TYPES.TEXT },
      { label: "Last Name", key: PROFILE_FIELD_KEYS.LAST_NAME, type: FIELD_TYPES.TEXT },
      {
        label: "Country",
        key: PROFILE_FIELD_KEYS.COUNTRY,
        type: FIELD_TYPES.DROPDOWN,
        options: [],
      },
      { label: "Email Address", key: PROFILE_FIELD_KEYS.EMAIL, type: FIELD_TYPES.TEXT },
    ],
  },
  {
    fields: [
      { label: "Company", key: PROFILE_FIELD_KEYS.COMPANY, type: FIELD_TYPES.TEXT },
      { label: "Title", key: PROFILE_FIELD_KEYS.TITLE, type: FIELD_TYPES.TEXT },
      { label: "Role", key: PROFILE_FIELD_KEYS.ROLE, type: FIELD_TYPES.TEXT },
      {
        label: "Function/Responsibilities",
        key: PROFILE_FIELD_KEYS.FUNCTION,
        type: FIELD_TYPES.DROPDOWN,
        options: DeveloperProfileConstants.OPTIONS.jobRoles,
      },
    ],
  },
  {
    fields: [
      {
        label: "Years of Experience",
        key: PROFILE_FIELD_KEYS.EXPERIENCE,
        type: FIELD_TYPES.DROPDOWN,
        options: DeveloperProfileConstants.OPTIONS.experienceLevels,
      },
      {
        label: "Technical Expertise",
        key: PROFILE_FIELD_KEYS.EXPERTISE,
        type: FIELD_TYPES.DROPDOWN,
        options: DeveloperProfileConstants.OPTIONS.technicalExpertise,
      },
    ],
  },
  {
    fields: [
      {
        label: "Programming Language",
        key: PROFILE_FIELD_KEYS.LANGUAGE,
        type: FIELD_TYPES.DROPDOWN,
        options: DeveloperProfileConstants.OPTIONS.programmingLanguages,
      },
      {
        label: "Architecture & Tools/Topics",
        key: PROFILE_FIELD_KEYS.TOOLING,
        type: FIELD_TYPES.MULTISELECT,
        options: DeveloperProfileConstants.OPTIONS.architectureTools,
      },
    ],
  },
];
